import React from 'react';

const toUrl = (m) => (typeof m === 'string' ? m : m?.url || m?.src || m?.path);

// Static cover for the compact (phone/tablet) brand cards and rows: the first
// gallery image, or a there2b gradient with the brand's initial when the brand
// has no images.
const BrandCompactCover = ({ media, name, initialClass = 'text-[40px]' }) => {
  const first = Array.isArray(media) ? media.map(toUrl).find(Boolean) : null;

  if (first) {
    return (
      <img
        src={first}
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
        loading="lazy"
        decoding="async"
      />
    );
  }

  const initial = (name || '').trim().charAt(0).toUpperCase();
  return (
    <div className="absolute inset-0 grid place-items-center bg-gradient-to-br from-brand-soft via-brand to-brand-deep">
      {initial && (
        <span
          aria-hidden="true"
          className={`font-extrabold leading-none text-white drop-shadow-sm ${initialClass}`}
        >
          {initial}
        </span>
      )}
    </div>
  );
};

export default BrandCompactCover;
